export const MIN_SKU_LENGTH = 1
export const MAX_SKU_LENGTH = 12
